export const pagesBlocksMap = {
  'pageBlocks_grid_BlockType': 'GridBlock',
  'pageBlocks_collectionsTeaser_BlockType': 'CollectionsTeaser',
}
